export default "<div class=\"video_container\">\r\n  <video id=\"my-video\" class=\"video-js videoTag\"></video>\r\n</div>\r\n";